import { EventBus } from "@/event-bus";

export var scrollUpdater = {

    data: function () {

    },

    created: function () {

        let tryLimit = 15;

        let intervalHandler = null;

        intervalHandler = setInterval(() => {

            window.scrollTo(0, 10);
            console.log("scrollUpdater:created: ", window.scrollY, "Try", tryLimit);

            if (window.scrollY > 0 || !tryLimit) {
                clearInterval(intervalHandler);
            }

            tryLimit--;

        }, 500);
    },

    afterCreate: function () {

    },

    methods: {

        scrollTopOverDetect: function (evt) {

            console.log(window.scrollY);

            if (window.scrollY !== 0) {
                return;
            }

            console.log("SCROLL ZERO");

            if (this.timeoutHandler) {
                clearTimeout(this.timeoutHandler);
            }

            this.timeoutHandler = setTimeout(() => {
                window.scrollTo(0, 10);
                console.log(window.scrollY);
                EventBus.$emit("scrollTopOverDetect");
            }, 500);
        }

    }
};